import React from 'react';
import { Container } from 'react-bootstrap';
var Footer = function Footer(_ref) {
    var brandName = _ref.brandName;
    return /*#__PURE__*/ React.createElement("footer", {
        className: "py-5 py-md-5"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("p", {
        className: "text-center mb-0"
    }, "\xA9 ", new Date().getFullYear(), " ", brandName)));
};
export default Footer;
